<template>
<div class="text-center">

  <v-menu
    offset-y
    >
    <template v-slot:activator="{ on: menuOn }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltipOn, attrs }">
          <v-btn v-on="Object.assign({}, menuOn, tooltipOn)" v-bind="attrs" icon>
            <v-icon size="20" color="black">mdi-format-align-{{ align }}</v-icon>
          </v-btn>
      </template>
      <span>{{ $t('pagetip_col5') }}</span>
      </v-tooltip>
    </template>
    <v-list>
      <v-list-item
        v-for="option in options"
        :key="option.value"
        @click="updateAlignment(option.value)"
      >
        <v-list-item-icon>
          <v-icon>{{ option.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ option.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</div>
</template>
  
  <script>
  export default {
  
      props:{
          obj:{type:Object, default:null},
          title:{type:String, default: ""},
          align:{type:String, default:"center"},
          path:{type:String, default:""},
      },
  
      setup(){
  
      },
  
      mounted(){
          //console.log(this.align);
      },
  
      data: ()=> ({
          dialog_com : false,
          disabled:false,
  
          options: [
            { label: "Left",    value: "left",    icon: "mdi-format-align-left" },
            { label: "Center",  value: "center",  icon: "mdi-format-align-center" },
            { label: "Right",   value: "right",   icon: "mdi-format-align-right" },
          ],          
          
          selectalign:"",
          text_backup:"",

      }),
  
  
      methods: {
  
        updateAlignment(value) {
          this.selectalign = value;
          this.updateRender();
        },        

          //다이얼로그 닫기
          close_com () {
              this.$emit('callback', this.text_backup, this.path, this.obj);
              this.dialog_com = false
          },
  
          //추가 저장
          save_com () {
              //콜백 호출 후 닫아야함.
              //this.$emit('callback');
              this.updateRender();
              this.dialog_com = false
          },      
  
          menu_handler(){
              //console.log("menu_handler");
              this.selectalign = this.align;
              this.text_backup = this.align;
          },
  
          //편집창 컴포넌트 렌더링
          updateRender(){
              this.$emit('callback', this.selectalign, this.path, this.obj);
          },
  
      }
  
  
  }
  </script>
  